import React from 'react'
import { message, Popconfirm, Switch, Tooltip } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import styled from 'styled-components'

import { deleteTag, toggleTag } from '../services'
import { handleError } from '../../../helpers'

export default function TagItem({ tag, reload, reloadTags, model, modelType }) {
	
	const handleToggle = () => {
		toggleTag({
			model_type: modelType,
			model_id: model.id,
			tag_id: tag.id
		})
			.then(res => {
				message.success(res.data.message)
				reload()
			})
			.catch(error => handleError(error))
	}

	const isChecked = id => {
		let ids = model.tags.filter(c => c.id === id)
		return ids.length === 0 ? false : true
	}

	const handleDelete = () => {
		deleteTag(tag.id)
			.then(res => {
				message.success(res.data.message)
				reloadTags()
			})
			.catch(error => handleError(error))
	}
	
	return (
		<React.Fragment>
			<Row>
				<Col>
					<Switch 
						checked={isChecked(tag.id)}
						onChange={handleToggle}
						size="small"
					/>
				</Col>
				<Col className='ml-2' style={{ flex: 1 }}>
					{tag.name}
				</Col>
				<Col className='px-2'>
					<Tooltip title="Eliminar">
						<Popconfirm
							title="Se eliminar esta etiqueta de TODO el sistema"
							okText="Eliminar"
							cancelText="Cancelar"
							onConfirm={() => handleDelete()}
							okButtonProps={{ danger:true }}
						>
							<FontAwesomeIcon className="text-link" icon={faTrash} />
						</Popconfirm>
					</Tooltip>
				</Col>
			</Row>
		</React.Fragment>
	)
}

const Row = styled.div`
	display: flex;
	margin-bottom: 7px;
`

const Col = styled.div``